module.exports = __webpack_public_path__ + "img/jdyd.14b4f160.jpg";